import { Controller } from "@hotwired/stimulus";

// Brings its element into view on load, for links that open a page on one section without a URL fragment.
export default class extends Controller {
  connect() {
    requestAnimationFrame(() =>
      this.element.scrollIntoView({ block: "start" }),
    );
  }
}
